
import { Vue, Component } from 'vue-property-decorator';
import { FlightPathServiceInterface } from '@/flightpath-components/services/FlightPathServiceInterface';
import { Container } from 'inversify';
import SERVICE_IDENTIFIER from '@/flightpath-components/services/identifiers';
import { SimplePath } from '@/flightpath-components/models/SimplePath';
import { Guid } from 'guid-typescript';
import { PathHelper } from '@/utils/PathHelper';
import { GPSLocation } from '@/flightpath-components/models/GPSLocation';
import { SimplePoint } from '@/flightpath-components/models/SimplePoint';
import GlobalStore from '@/store/modules/global';
import { getModule } from 'vuex-module-decorators';

// Define the component in class-style
/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({ name: 'UploadPath', inject: ['container'] })
export default class UploadPath extends Vue {
  globalStore = getModule(GlobalStore, this.$store);
  // IoC container provided from App.ts is injected here
  private flightPathService: FlightPathServiceInterface | undefined = undefined;
  private container!: Container;
  file: File | null = null;
  content = '';
  loading = false;
  async previewFile(e: File) {
    this.content = await e.text();
  }

  async validateUpload() {
    try {
      this.loading = true;
      const fileContents = await this.file?.text();
      if (fileContents == undefined) return;
      const result = JSON.parse(fileContents) as SimplePath;
      if (result.Path.length == 0) {
        console.error('path has no points');
      }
      if (result.Name == null || result.Name == '') {
        result.Name = `path_upload_${new Date().toDateString()}`;
      }

      // convert to GPS location to remove duplicate points

      const path = result.Path.map((value) => {
        return { Latitude: value.Lat, Longitude: value.Long, Elevation: value.Alt } as GPSLocation;
      });
      const distinctPath = PathHelper.removeDuplicateSuccessivePoints(path);

      // convert back to simple points
      const distinctSimplePath = distinctPath.map((value) => {
        return { Lat: value.Latitude, Long: value.Longitude, Alt: value.Elevation } as SimplePoint;
      });

      const newPath = new SimplePath();
      newPath.PathID = Guid.create().toString();
      newPath.CustomerID = this.globalStore.accountId;
      newPath.Name = result.Name;
      newPath.Path = distinctSimplePath;
      newPath.WorkAreas = result.WorkAreas;
      newPath.FieldID = Guid.createEmpty().toString();
      newPath.PathLengthMeters = result.PathLengthMeters;
      newPath.StrokeOpacity = 0.5;
      newPath.StrokeWeight = 1;
      newPath.LastModifiedUTC = new Date();

      await this.flightPathService?.insertOrUpdatePath(newPath);
      this.content = '';
    } catch (error) {
      console.error(error);
      this.content = error;
    } finally {
      this.loading = false;
      this.file = null;
    }
  }
  created(): void {
    this.flightPathService = this.container.get<FlightPathServiceInterface>(SERVICE_IDENTIFIER.FLIGHT_PATH);
  }

  async mounted() {
    if (this.flightPathService != undefined) await this.flightPathService.updateToken();
  }
}
